import { useState, useCallback } from 'react';

/**
 * Manages which detail content to show on Page 3 (Detail page).
 * When a dashboard card is tapped, it sets the detail type and
 * the parent navigates to page 2 (detail).
 */
export function useDetailContext() {
  const [detailType, setDetailType] = useState(null);
  const [detailParams, setDetailParams] = useState({});

  const openDetail = useCallback((type, params = {}) => {
    setDetailType(type);
    setDetailParams(params);
  }, []);

  const clearDetail = useCallback(() => {
    setDetailType(null);
    setDetailParams({});
  }, []);

  return { detailType, detailParams, openDetail, clearDetail };
}
